export default "__VITE_ASSET__BW0ZgWv2__"